import styled, { css } from 'styled-components/native';
import { RFValue } from 'react-native-responsive-fontsize';

type CardState = 'loading' | 'success' | 'error';

interface CardProps {
  state?: CardState;
}

interface SkeletonLineProps {
  width?: string;
  height?: number;
}

export const Card = styled.View<CardProps>`
  border-radius: ${RFValue(12)}px;
  flex-direction: row;
  align-items: center;
  min-height: ${RFValue(62)}px;
  padding: ${RFValue(12)}px ${RFValue(14)}px;
  margin-bottom: ${RFValue(12)}px;
  gap: ${RFValue(12)}px;
  overflow: hidden;

  ${({ state, theme }) => {
    if (state === 'error') {
      return css`
        background-color: ${theme.colors.attention_opacity};
        border-left-width: 3px;
        border-left-color: ${theme.colors.attention};
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 0px;
      `;
    }
    if (state === 'loading') {
      return css`
        background-color: ${theme.colors.background_secondary};
        border-width: 1px;
        border-color: ${theme.colors.border};
      `;
    }
    return css`
      background-color: ${theme.colors.blue_main_opacity};
      border-left-width: 3px;
      border-left-color: ${theme.colors.blue};
      border-top-width: 0px;
      border-right-width: 0px;
      border-bottom-width: 0px;
      shadow-radius: 6px;
    `;
  }}
`;

export const CardInfo = styled.View`
  flex: 1;
`;

export const CardModel = styled.Text`
  font-size: ${RFValue(13)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
  color: ${({ theme }) => theme.colors.title};
`;

export const CardDetails = styled.Text`
  font-size: ${RFValue(11)}px;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.text};
  margin-top: ${RFValue(2)}px;
`;

export const CardError = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.attention};
  flex: 1;
`;

export const SkeletonLine = styled.View<SkeletonLineProps>`
  height: ${({ height }) => RFValue(height ?? 11)}px;
  border-radius: ${RFValue(4)}px;
  background-color: ${({ theme }) => theme.colors.border};
  width: ${({ width }) => width ?? '60%'};
`;